import { useTranslation } from 'react-i18next';

import { ConfirmationModal } from '@/modules/common/components/modals/confirmation-modal';

interface UnsavedChangesModalProps {
  open: boolean;
  onClose: () => void;
  onDiscard: () => void;
  /** Label inserted into the description (e.g. "invoices", "bills") */
  entity: string;
  isLoading?: boolean;
}

/**
 * Confirmation modal used across the finance module's generate flows when
 * the user tries to navigate away from a dirty form. i18n keys live under
 * `common.generateEntities.unsavedChanges` and are entity-agnostic — the
 * concrete entity word is passed as the `entity` interpolation.
 */
export function UnsavedChangesModal({
  open,
  onClose,
  onDiscard,
  entity,
  isLoading = false,
}: UnsavedChangesModalProps) {
  const { t } = useTranslation('common', { keyPrefix: 'generateEntities.unsavedChanges' });

  const handleConfirm = (closeModal: () => void) => {
    onDiscard();
    closeModal();
  };

  return (
    <ConfirmationModal
      open={open}
      onOpen={() => {}}
      onClose={onClose}
      title={t('title')}
      message={t('description', { entity })}
      confirmText={t('confirm')}
      cancelText={t('cancel')}
      confirmVariant="destructive"
      onConfirm={handleConfirm}
      isLoading={isLoading}
    />
  );
}
